import React, { useState } from 'react';
import { Helmet } from "react-helmet";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Layout } from '../layouts/Main';
import { BlockPostSellbox, BreadCrumbBlock } from '../components';
import { FaRegEnvelope, FaSpinner, FaPhoneAlt, FaGlobe, FaArrowRight } from 'react-icons/fa';
import Recaptcha from 'react-recaptcha';
import { Link } from 'gatsby';

import {
  Header,
  Footer,
} from "../components";

const ContactSupport = ({ location }) => {
  const [showThankYouMessage, toggleShowThankYouMessage] = useState(false);
  const [recaptchaError, toggleRecaptchaError] = useState(false);

  const submitSuccess = (data = {}, setSubmitting) => {
    // toggleShowThankYouMessage(true);
    // toggleShowNoForm(false);
    // toggleShowYesForm(false);
    if(checkGrecaptcha()) {
      console.log('grecaptcha ok...');
      fetch('https://www.freeconferencecall.com/contact-us/send_message', {
        method: 'post',
        body: JSON.stringify(data)
      }).then(response => {
        return response.json();
      }).then(data => {
        console.log(data);
        setSubmitting(false);
      }, (error) => {
        console.log(error);
        setSubmitting(false);
      }
      );
    }
  }

  const checkGrecaptcha = () => {
    if (typeof window !== 'undefined') {
      if (window.grecaptcha && !window.grecaptcha.getResponse().length) {
        console.log('Please fix grecaptcha box');
        toggleRecaptchaError(true);
        return false;
      }
    }
    return true;
  }

  return (
    <Layout>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1, minimum-scale=1" />
        <title>FreeConferenceCall Support Center - Contact Us</title>
      </Helmet>
      <Header />
      <BlockPostSellbox title="Contact Us" title_centered />
      <BreadCrumbBlock location={location} label="Contact Us" />
      
      <div className="block-sm contactus">
        <div className="container">
          <h2 className="section-title">Send us your comments</h2>
          <div className="row">
            <div className="col-md-5">
              <p>Submit a trouble ticket or simply leave a feedback here</p>

              <iframe src="/contact-us-form" width="100%" height="500" scrolling="no" className="contactus-iframe"></iframe>

              {/* Contactus Form */}
              {/* <div className={`contactus-form ${showThankYouMessage ? 'hidden' : null}`}>
                <Formik
                  initialValues={{ 
                    name: '',
                    email: '',
                    phone: '',
                    meeting_id: '',
                    comments: '',
                  }}
                  validate={values => {
                    const errors = {};
                    if (!values.name) {
                      errors.name= 'This value is required';
                    }
                    if (!values.email) {
                      errors.email= 'This value is required';
                    }
                    else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
                      errors.email = 'Invalid email address';
                    }
                    if (!values.comments) {
                      errors.comments = 'This value is required';
                    }
                    checkGrecaptcha();

                    return errors;
                  }}
                  onSubmit={(values, { setSubmitting }) => {
                    console.log(values);

                    submitSuccess(values, setSubmitting);
                    // setSubmitting(false);
                  }}
                >
                  {({ isSubmitting, errors, touched }) => (
                    <Form>
                      <div className="form-group">
                        <Field type="text" name="name" className={`form-control ${touched.name && errors.name ? 'field-errors' : ''}`} placeholder="Name" />
                        <ErrorMessage name="name" component="div" className="field-error-message"/>
                      </div>
                      <div className="form-group">
                        <Field type="email" name="email" className={`form-control ${touched.email && errors.email ? 'field-errors' : ''}`} placeholder="Email address" />
                        <ErrorMessage name="email" component="div" className="field-error-message"/>
                      </div>
                      <div className="form-group">
                        <Field type="tel" name="phone" className={`form-control ${touched.phone && errors.phone ? 'field-errors' : ''}`} placeholder="Phone" />
                        <ErrorMessage name="phone" component="div" className="field-error-message"/>
                      </div>
                      <div className="form-group">
                        <Field type="text" name="meeting_id" className={`form-control ${touched.meeting_id && errors.meeting_id ? 'field-errors' : ''}`} placeholder="Online Meeting ID" />
                        <ErrorMessage name="meeting_id" component="div" className="field-error-message"/>
                      </div>
                      <div className="form-group">
                        <Field component="textarea" rows="6" className={`form-control ${touched.comments && errors.comments ? 'field-errors' : ''}`} name="comments" placeholder="comments" style={{width: '100%'}} />
                        <ErrorMessage name="comments" component="div" className="field-error-message" />
                      </div>
                      <div className={`form-group g-recaptcha-section ${recaptchaError ? 'g-recaptcha-error' : null}`}>
                        <Recaptcha 
                          sitekey="6Ldw2wATAAAAAPrc0sIk2o7FxSX5ZwzkHm55xu2i"
                          verifyCallback={() => {toggleRecaptchaError(false)}}
                          expiredCallback={() => {toggleRecaptchaError(true)}}
                        />
                        <div className={`field-error-message ${recaptchaError ? null : 'hidden'}`}>reCAPTCHA is required</div>
                      </div>
                      <div className="form-group">
                        <button type="submit" disabled={isSubmitting} className="btn btn-blue pull-right">
                            <FaSpinner className={`icon-spin icon ${isSubmitting? '' : 'hidden'}`}/>
                            Send feedback
                          </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div> */}
              

            </div>
            <div className="col-md-4 col-md-offset-1">
              <div className="border-box">

                <div className="flex">
                  <FaRegEnvelope className="icon"/>
                  <strong>Customer Support Email</strong>
                </div>
                <a href="mailto: support@freeconferencecall.com" title="support@freeconferencecall.com">support@freeconferencecall.com</a>

                <div className="flex">
                  <FaPhoneAlt className="icon" />
                  <strong>Customer Support Number</strong>
                </div>
                <a href="tel: 1-844-844-1322" title="1 (844) 844-1322">1 (844) 844-1322</a>

                <div className="flex">
                  <FaGlobe className="icon" />
                  <strong>International Customer Support </strong>
                </div>
  
              </div>
              {/* <div className="border-box">
                <div className="flex">
                  <div className="left-content">
                    <h5>Scheduled Maintenance</h5>
                    <Link to="/operational-status" title="Scheduled Maintenance">
                      Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut
                    </Link>
                  </div>
                  <div className="right-content">
                    <Link to="/operational-status" title="Scheduled Maintenance">
                      <FaArrowRight className="arrow-icon" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="border-box">
                <div className="flex">
                  <div className="left-content">
                    <h5>Operation Status</h5>
                    <Link to="/operational-status" title="Operational Status">
                      Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut
                    </Link>
                  </div>
                  <div className="right-content">
                    <Link to="/operational-status" title="Operational Status">
                      <FaArrowRight className="arrow-icon" />
                    </Link>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </Layout>
  )
}
export default ContactSupport
